import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const preferencesAccountSchema = z.object({
  shortRestLocationId: z.number().nullable().optional(),
  longRestLocationId: z.number().nullable().optional(),
  preferredFuelLocations: z.array(z.number()).nullable().optional(),
  accountId: z.number(),
  lastModifienOn: coercedDate.optional(),
});

export type PreferencesAccount = z.infer<typeof preferencesAccountSchema>;
